export enum ProvidedFilters {
  CustomerType = 'customerType',
  EnergyType = 'energyType',
  TariffType = 'tariffType',
  PlanName = 'planName',
}

export type FiltersType = {
  customerType: string;
  energyType: string;
  tariffType: string;
  planName: string;
};

export enum RatesSearchParams {
  Postcode = 'postcode',
  PlanID = 'planID',
}
